import { c as _c } from "react/compiler-runtime";
import { SearchInput, SelectInput } from '@/components/inputs';
import { addPrefixToDataParams } from '@/utils/string';
import React from 'react';
import { Form, Field, FormSpy } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { SELECT_ALL_VALUE } from '@/hooks/searchParamParsers';
import { FIELD_CATEGORY, FIELD_COUPON, FIELD_FULLTEXT, SearchFormValues } from './hooks/useFormSearch';
import { Category } from './functions/getCategories';
import { LINKS } from '@/constants/links';
import { addSearchParams } from '@/utils/fetcher';
import { FormApi } from 'final-form';
import { logEvent } from '@/analytics/events';
import { useRouter } from 'next/router';
function Search(t0) {
  const $ = _c(20);
  const {
    categories,
    initialValues,
    onSearch,
    searchForm
  } = t0;
  const {
    t
  } = useTranslation("discounts");
  const router = useRouter();
  let t1;
  if ($[0] !== t) {
    t1 = t("form.allCategoriesOption");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      label: t1,
      value: SELECT_ALL_VALUE
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const allCategoriesOption = t2;
  let t3;
  if ($[4] !== allCategoriesOption || $[5] !== categories) {
    t3 = categories?.length > 0 ? [allCategoriesOption, ...categories.map(_temp)] : [allCategoriesOption];
    $[4] = allCategoriesOption;
    $[5] = categories;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const categoryOptions = t3;
  let t4;
  if ($[7] !== categories || $[8] !== onSearch || $[9] !== router) {
    t4 = values => {
      onSearch(values);
      if (!router.isReady) {
        return;
      }
      if (values[FIELD_CATEGORY]) {
        if (values[FIELD_CATEGORY] === SELECT_ALL_VALUE && router.pathname !== LINKS().discounts) {
          router.push(addSearchParams(LINKS().discounts, {
            [FIELD_FULLTEXT]: values[FIELD_FULLTEXT],
            [FIELD_COUPON]: values[FIELD_COUPON]
          }), undefined, {
            shallow: true
          });
        } else {
          if (router.pathname !== LINKS().discountsCategory(values[FIELD_CATEGORY])) {
            const category_1 = categories?.find(category_0 => category_0.id === values[FIELD_CATEGORY]);
            if (category_1) {
              router.push(addSearchParams(LINKS().discountsCategory(category_1.slug), {
                [FIELD_FULLTEXT]: values[FIELD_FULLTEXT],
                [FIELD_COUPON]: values[FIELD_COUPON]
              }), undefined, {
                shallow: true
              });
            }
          }
        }
      }
    };
    $[7] = categories;
    $[8] = onSearch;
    $[9] = router;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const setFilter = t4;
  const logSearchEvent = _temp2;
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = value => {
      logSearchEvent("search_by_eshop", value);
    };
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const logSearchFulltextEvent = t5;
  let t6;
  if ($[12] !== categoryOptions || $[13] !== initialValues || $[14] !== setFilter || $[15] !== t) {
    t6 = t7 => {
      const {
        form,
        handleSubmit
      } = t7;
      return <><FormSpy subscription={{
          values: true
        }} onChange={t8 => {
          const {
            values: values_0
          } = t8;
          return setFilter(values_0);
        }} /><form onSubmit={handleSubmit} {...addPrefixToDataParams({
          analyticsParam: "discountsSearch",
          testId: "discountsSearch",
          prefix: "form"
        })} className="pb mb-12 grid grid-cols-1 grid-rows-2 gap-4 lg:grid-cols-4 lg:grid-rows-1 lg:rounded-2xl lg:bg-white lg:p-6"><Field name={FIELD_COUPON} initialValue={initialValues?.[FIELD_COUPON]}>{_temp3}</Field><Field name={FIELD_FULLTEXT} className="lg:col-span-3" initialValue={initialValues?.[FIELD_FULLTEXT]}>{fieldRenderProps_0 => <SearchInput {...fieldRenderProps_0} label={t("form.searchLabel")} hideLabel={true} onClean={() => {
              form.change(FIELD_FULLTEXT, undefined);
              logSearchFulltextEvent(SELECT_ALL_VALUE);
            }} onChange={value_0 => {
              logSearchFulltextEvent(value_0);
            }} />}</Field><Field name={FIELD_CATEGORY} initialValue={initialValues?.[FIELD_CATEGORY]}>{fieldRenderProps_1 => <SelectInput {...fieldRenderProps_1} label={t("form.categoryLabel")} hideLabel={true} options={categoryOptions} onSelect={selectedValue => {
              logSearchEvent("search_by_category", categoryOptions.find(t9 => {
                const {
                  value: value_1
                } = t9;
                return value_1 === selectedValue;
              })?.label);
            }} />}</Field></form></>;
    };
    $[12] = categoryOptions;
    $[13] = initialValues;
    $[14] = setFilter;
    $[15] = t;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== searchForm || $[18] !== t6) {
    t7 = <Form form={searchForm} onSubmit={searchForm.submit}>{t6}</Form>;
    $[17] = searchForm;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}
function _temp3(fieldRenderProps) {
  return <input {...fieldRenderProps.input} type="hidden" />;
}
function _temp2(action, term) {
  if (term) {
    logEvent("search", {
      action,
      search_term: term
    });
  }
}
function _temp(category) {
  return {
    label: category.name,
    value: category.id
  };
}
export default Search;